import {
	LocationClient,
	Place,
	SearchPlaceIndexForTextCommand,
} from "@aws-sdk/client-location";
import { withAPIKey } from "@aws/amazon-location-utilities-auth-helper";
import { produce } from "immer";
import { create } from "zustand";
import geohash from "ngeohash";
import { IAffairPub } from "@api/affair.int";
import { TCoordinate, TGeoGroupLevel, TGeoGroupLevelAll } from "@api/api.int";
import { IGeoGroupPub } from "@api/geo-group.int";
import { IUserPub, TGuardKind, TUserSummary } from "@api/auth.int";

const REGION = "eu-central-1";
const LOCATION_CLIENT_API_KEY =
	"v1.public.eyJqdGkiOiI2M2NkZDRjNS0xYWU4LTQ5MjAtODFjNC03OGYwN2IzZmUzM2EifRIW21Za8Pf1gSuFuQoUnQckfGejIITH0iQ2hzOPsJx4OLDMCp1pY8SbAurCrEHyZJsDRCvMAkEd9PO6Tt_h6Nmzo4HHqG4bcWY9jS80NVyUZjfK9oO7VaxJ7t4VfO0YiYBwh7oXpqDpPiWEd7I3_o0rw2pFApDY5zN8gGiN-fD2oIQ7WPiVONM9oXV3NVCogFTfoLpjrwCZkoiLUOiiuKYEHjaf6J9_eq7Pz457KVShSisBSw1Wb9xM7QZb4ImV3OLQK4SyzchXQTnx9MAfK-4RE4eNGqO6V3aAQ_sjdVbzSCHSW6Q88io4cpg4XkAVSUAg27NvW0q5HndFFEbVqG8.Y2MzMTcwNWYtZTgwMy00NGZlLWFiNGItNzVkMDFmMDM0Nzcy";

export interface IMoveIntoView {
	zoom: number;
	center: TCoordinate;
}

export const GEO_GROPUS: Array<{
	geoGroup: TGeoGroupLevelAll;
	zoom: number;
	zoomIn: number;
	geoHashPrec: number;
}> = [
	{ geoGroup: "Location", zoom: 13.5, zoomIn: 13.5, geoHashPrec: 5 },
	{ geoGroup: "Municipality", zoom: 11.5, zoomIn: 13.5, geoHashPrec: 4 },
	{ geoGroup: "SubRegion", zoom: 10, zoomIn: 11.5, geoHashPrec: 4 },
	{ geoGroup: "Region", zoom: 8.5, zoomIn: 10, geoHashPrec: 5 },

	{ geoGroup: "SubMunicipality", zoom: 11.5, zoomIn: 13.5, geoHashPrec: 4 },
	{ geoGroup: "Municipality-Region", zoom: 8.5, zoomIn: 11, geoHashPrec: 5 },
];
/*[
        { geoGroup: 'Location', zoom: 14, geoHashPrec: 5 },
        { geoGroup: 'Municipality', zoom: 12.5, geoHashPrec: 4 },
        { geoGroup: 'SubRegion', zoom: 11, geoHashPrec: 4 },
        { geoGroup: 'Region', zoom: 9.5, geoHashPrec: 5 },
    ];*/

export type TAffairKind =
	| "vizminoseg"
	| "csotores"
	| "kozkut"
	| "dugulas"
	| "eloviz";


export type IMapItemKind = "Affair" | "Guard" | "Group" | "FindCity";
export type TMapItemSubKind = any;//TAffairKind | TGuardKind | "group" | "findcity";

export interface ILocationBase {
	title: string;
	kind: IMapItemKind;
	subKind: TMapItemSubKind;
	isNew: boolean;
	geoLng: number;
	geoLat: number;
}

export interface ILocationAffairNew extends ILocationBase {
	kind: "Affair";
	isNew: true;
	subKind: TAffairKind;
}
export interface ILocationAffair extends ILocationBase {
	kind: "Affair";
	isNew: false;
	subKind: TAffairKind;
	dbAffair: IAffairPub;
}
export interface IlocationGuardNew extends ILocationBase {
	kind: "Guard";
	isNew: true;
	subKind: TGuardKind;
}
export interface IlocationGuard extends ILocationBase {
	kind: "Guard";
	isNew: false;
	subKind: TGuardKind;
	dbGuard: IUserPub;
}
export interface ILocationGroup extends ILocationBase {
	kind: "Group";
	isNew: false;
	subKind: "group";
	dbGroup: IGeoGroupPub;
}
export interface ILocationFindCity extends ILocationBase {
	kind: "FindCity";
	isNew: false;
	subKind: "findcity";
}
export type ILocation =
	| ILocationAffair
	| ILocationAffairNew
	| IlocationGuard
	| IlocationGuardNew
	| ILocationGroup
	| ILocationFindCity;

export function isLocationAffair(loc: ILocation): loc is ILocationAffair {
	return (loc as ILocationAffair).dbAffair !== undefined;
}
export function isLocationGuard(loc: ILocation): loc is IlocationGuard {
	return (loc as IlocationGuard).dbGuard !== undefined;
}
export function isLocationGroup(loc: ILocation): loc is ILocationGroup {
	return (loc as ILocationGroup).dbGroup !== undefined;
}

export type TMapMode = "SHOW" | "SELECT";

// --------------- resize ------------------
export type TViewSize = "sm" | "md" | "lg";
export type TLayoutPush = "no" | "menu" | "menu_and_tools";

// ======================================================================= STATE INTERFACE ============================================
export type TMapNavRoot = ((path: string) => string);
export const MAP_NAV_ROOT_EMPTY = ((path:string)=>path);

export interface IVVState {
	// ------------- layout ----------------
	__viewSize: [number, number];
	__viewSizeChanged: () => void;
	isMobile: () => boolean;
	isFull: () => boolean;

	layoutPush: TLayoutPush;
	setLayoutPush: (v: TLayoutPush) => void;
	__toolsWidthPx: number;
	__isToolDetailed: boolean;
	isToolDetailed: () => boolean;
	setTool: (toolWithPx: number, isToolDetailed: boolean) => void;

	getMenuWidth: () => string;
	isTools: () => boolean;
	getToolsWidth: () => string;
	getMainWidth: () => string;

	getDetailsWidth: () => string;

	mapNavRoot: TMapNavRoot;
	setMapNavRoot: (v: TMapNavRoot) => void;

	// ------------- profile ----------------
	myProfile: IUserPub | undefined;
	setMyProfile: (v: IUserPub | undefined) => void;
	addUserSummary: (key: keyof TUserSummary, add : number) => void;

	createLngLat: TCoordinate | undefined;
	setCreateLngLat: (v: TCoordinate | undefined) => void;

	// ------------- map things ----------------
	locationClient: LocationClient;

	mapMode: TMapMode;
	setMapMode: (v: TMapMode) => void;
	mapMoveIntoView: IMoveIntoView | undefined;
	setMapMoveIntoView: (v: IMoveIntoView | undefined) => void;

	// loading
	loadingMunicipalities: Array<string>;
	addLoadingMunicipalities: (keys: string[]) => void;
	removeLoadingMunicipalities: (keys: string[]) => void;
	loadedMunicipalities: Array<string>;
	addLoadedMunicipalities: (keys: string[]) => void;

	// loaded
	itemsList: ILocation[];
	groupList: IGeoGroupPub[];
	affairList: IAffairPub[];
	guardList: IUserPub[];
	addGroupItems: (groups: IGeoGroupPub[]) => void;
	addAffairItems: (affairs: IAffairPub[]) => void;
	addGuardItems: (guards: IUserPub[]) => void;
	removeGuardItem: (guard: IUserPub) => void;
	removeAffairItem: (affair: IAffairPub) => void;

	// dynamics
	suggestionList: ILocation[];
	setSuggestionList: (list: ILocation[]) => void;

	resetAfterAction: () => void;

	facebookLogin: () => Promise<void>;
}

// ======================================================================= STATE ============================================
export const MENU_WIDTH_PX_LG = 340;
export const LAYOUT_SM_WIDTH = 1024;
export const LAYOUT_LG_WIDTH = 1440;
export const useVVStore = create<IVVState>()(
	(set, get) => ({
		// ------------- layout ----------------
		__viewSize: [window.innerWidth, window.innerHeight],
		__viewSizeChanged: () => {
			set(produce((state: IVVState) => {
				state.__viewSize = [window.innerWidth, window.innerHeight];
				const body = document.querySelector("body");
				if (window.innerWidth < LAYOUT_SM_WIDTH) {
					body?.classList.add("body-mobile");
					body?.classList.remove("body-not-mobile");
				} else {
					body?.classList.add("body-not-mobile");
					body?.classList.remove("body-mobile");
				}
				if (window.innerWidth >= LAYOUT_LG_WIDTH) {
					body?.classList.add("body-full");
					body?.classList.remove("body-not-full");
				} else {
					body?.classList.add("body-not-full");
					body?.classList.remove("body-full");
				}
			}));
		},
		isMobile: () => get().__viewSize[0] < LAYOUT_SM_WIDTH,
		isFull: () => get().__viewSize[0] >= LAYOUT_LG_WIDTH,

		getMenuWidth: () =>
			get().isMobile() ? "100vw" : MENU_WIDTH_PX_LG + "px",
		getMainWidth: () =>
			get().isMobile()
				? "100vw"
				: (get().__viewSize[0] - MENU_WIDTH_PX_LG) + "px",

		getToolsWidth: () =>
			get().isMobile() ? "100vw" : (get().__toolsWidthPx) + "px",
		isTools: () => get().__toolsWidthPx > 0,

		__toolsWidthPx: 0,
		__isToolDetailed: false,
		isToolDetailed: () => get().__isToolDetailed,
		setTool: (toolWithPx: number, isToolDetailed: boolean) => {
			set(produce((state: IVVState) => {
				state.__toolsWidthPx = toolWithPx;
				state.__isToolDetailed = isToolDetailed;
			}));
			if (!get().isMobile() && toolWithPx > 0) {
				get().setLayoutPush('menu');
			}
		},

		getDetailsWidth: () => {
			if (get().isMobile()) {
				return "100wv";
			}
			if (get().layoutPush === "no") {
				return (get().__viewSize[0] - MENU_WIDTH_PX_LG -
					get().__toolsWidthPx) + "px";
			}
			return (get().__viewSize[0] - get().__toolsWidthPx) + "px";
		},

		layoutPush: "no",
		setLayoutPush: (v: TLayoutPush) => {
			set(produce((state: IVVState) => {
				state.layoutPush = v; //state.isMobile() || state.__mapToolsWidthPx>0 ? v : 0;
			}));
		},

		mapNavRoot: MAP_NAV_ROOT_EMPTY,
		setMapNavRoot: (v: TMapNavRoot) => {
			set(produce((state: IVVState) => {
				state.mapNavRoot = v;
			}));
		},
		// ==================================================== PROFILE ============================================

		myProfile: undefined,
		setMyProfile: (v: IUserPub | undefined) => {
			set(produce((state: IVVState) => {
				state.myProfile = v;
			}));
		},

		addUserSummary: (key: keyof TUserSummary, add : number) => {
			set(produce((state: IVVState) => {
				if (state.myProfile && state.myProfile.userSummary)
					state.myProfile.userSummary[key] += add;
			}));
		},

		// ==================================================== CREATE ============================================
		// ---------------------------- moveintoview ----------------------
		mapMoveIntoView: undefined,
		setMapMoveIntoView: (v: IMoveIntoView | undefined) => {
			set(produce((state: IVVState) => {
				state.mapMoveIntoView = v;
			}));
		},

		locationClient: undefined as any,

		itemsList: [],
		groupList: [],
		affairList: [],
		guardList: [],
		loadedMunicipalities: [],
		loadingMunicipalities: [],
		suggestionList: [],
		mapMode: "SHOW",
		createLngLat: undefined,
		fbStatus: undefined,

		// ==================================================== ADD GROUP ITEM ============================================
		addGroupItems(groups: IGeoGroupPub[]) {
			set(produce((state: IVVState) => {
				for (let group of groups) {
					let groupIx = state.groupList.findIndex((g) =>
						g.groupKey === group.groupKey
					);
					if (groupIx !== -1) {
						state.groupList[groupIx] = group;
					} else {
						state.groupList.push(group);
					}

					const locData: ILocationGroup = {
						kind: "Group",
						subKind: "group",
						isNew: false,
						title: group.title,
						//geoGroupXXX: group.geoGroupLevel,
						geoLng: group.longLat[0],
						geoLat: group.longLat[1],
						dbGroup: group,
					};

					let itemIx = state.itemsList.findIndex((g) =>
						isLocationGroup(g) &&
						g.dbGroup.groupKey === group.groupKey
					);
					if (itemIx !== -1) {
						state.itemsList[itemIx] = locData;
					} else {
						state.itemsList.push(locData);
					}
				}
			}));
		},

		addAffairItems(affairs: IAffairPub[]) {
			set(produce((state: IVVState) => {
				for (let affair of affairs) {
					let ix = state.affairList.findIndex((a) =>
						a.affairKey === affair.affairKey
					);
					if (ix !== -1) {
						state.affairList[ix] = affair;
					} else {
						state.affairList.push(affair);
					}

					const locData: ILocation = {
						kind: "Affair",
						subKind: affair.affairKind,
						isNew: false,
						title: affair.title,
						//geoGroupXXX: 'Location',
						geoLng: affair.longLat[0],
						geoLat: affair.longLat[1],
						dbAffair: affair,
					};
					ix = state.itemsList.findIndex((l) =>
						isLocationAffair(l) &&
						l.dbAffair.affairKey === affair.affairKey
					);
					if (ix !== -1) {
						state.itemsList[ix] = locData;
					} else {
						state.itemsList.push(locData);
					}
				}
			}));
		},

		addGuardItems(users: IUserPub[]) {
			set(produce((state: IVVState) => {
				for (let user of users) {
					console.log('addGuardItems', user);
					if (!user.guard) {
						continue;
					}
					let ix = state.guardList.findIndex((a) =>
						a.userKey === user.userKey
					);
					if (ix !== -1) {
						state.guardList[ix] = user;
					} else {
						state.guardList.push(user);
					}

					const locData: ILocation = {
						kind: "Guard",
						subKind: user.guard?.kind,
						isNew: false,
						title: user.userName,
						//geoGroupXXX: 'Location',
						geoLng: user.guard.longLat[0],
						geoLat: user.guard.longLat[1],
						dbGuard: user,
					};
					ix = state.itemsList.findIndex((l) =>
						isLocationGuard(l) && l.dbGuard.userKey === user.userKey
					);
					if (ix !== -1) {
						console.log(
							"UPDATE LOCATION",
							locData.geoLng,
							locData.geoLat,
						);
						state.itemsList[ix] = locData;
					} else {
						console.log(
							"NEW LOCATION",
							locData.geoLng,
							locData.geoLat,
						);
						state.itemsList.push(locData);
					}
				}
			}));
		},

		removeGuardItem: (user: IUserPub) => {
			set(produce((state: IVVState) => {
				state.guardList = state.guardList.filter(g => g.userKey !== user.userKey);
				state.itemsList = state.itemsList.filter(loc => !isLocationGuard(loc) || (loc.dbGuard.userKey !== user.userKey));
			}));
		},

		removeAffairItem: (affair: IAffairPub) => {
			set(produce((state: IVVState) => {
				state.affairList = state.affairList.filter(a => a.affairKey !== affair.affairKey);
				state.itemsList = state.itemsList.filter(loc => !isLocationAffair(loc) || (loc.dbAffair.affairKey !== affair.affairKey));
			}));
		},

		addLoadedMunicipalities: (keys: string[]) => {
			set(produce((state: IVVState) => {
				for (let key of keys) {
					state.loadedMunicipalities.push(key);
				}
			}));
		},
		addLoadingMunicipalities: (keys: string[]) => {
			set(produce((state: IVVState) => {
				for (let key of keys) {
					state.loadingMunicipalities.push(key);
				}
			}));
		},
		removeLoadingMunicipalities: (keys: string[]) => {
			set(produce((state: IVVState) => {
				let newArr = new Array<string>();
				state.loadingMunicipalities.forEach((oldKey) => {
					if (!keys.find((key) => oldKey === key)) {
						newArr.push(oldKey);
					}
				});
				state.loadingMunicipalities = newArr;
			}));
		},

		setSuggestionList: (list: ILocation[]) => {
			set(produce((state: IVVState) => {
				state.suggestionList = list;
			}));
		},

		setMapMode: (v: TMapMode) => {
			set(produce((state: IVVState) => {
				state.mapMode = v;
			}));
		},
		setCreateLngLat: (v: TCoordinate | undefined) => {
			set(produce((state: IVVState) => {
				state.createLngLat = v;
			}));
		},

		resetAfterAction: () => {
			set(produce((state: IVVState) => {
				state.suggestionList = [];
				state.mapMode = 'SHOW';
				state.createLngLat = undefined;
			}));
		},

		facebookLogin: async () => {
			FB.getLoginStatus(function (response) {
				//statusChangeCallback(response);
				console.log("FB LOGIN STATUS");
				console.log(response);
				if (response.status === "connected") {
					console.log(response.authResponse.signedRequest);
				}
			});
		},
	}),
);

// ----------------------------------------------------------------------------------------------------------- STARTUP ------------
(async () => {
	// -------------------- INIT FACEBOOK -----------------

	// ----------------------- INIT LOCATION CLIENT -----------------------
	const authHelper = await withAPIKey(LOCATION_CLIENT_API_KEY);
	const locationClient = new LocationClient({
		region: REGION,
		//...authHelper.getLocationClientConfig(), // Provides configuration required to make requests to Amazon Location
		...authHelper.getClientConfig(), // Provides configuration required to make requests to Amazon Location
	});

	useVVStore.setState({
		...useVVStore.getState(),
		locationClient,
	});
})();
